"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Pausable__factory", {
  enumerable: true,
  get: function get() {
    return _Pausable__factory.Pausable__factory;
  }
});

var _Pausable__factory = require("./Pausable__factory");